import {
  MdOutlineVpnLock,
  MdManageSearch,
  MdSystemSecurityUpdateGood,
} from "@onemind-services-llc/react-icons-ng/md";
import { GiFirewall } from "@onemind-services-llc/react-icons-ng/gi";

export const HEADING_CONSTANTS = {
  title: "Our Achievements",
  description:
    "OneMindServices LLC - CloudMyLab has been recognized with a prestigious international industry Cloud Award (The Security Awards 2025) for our cutting-edge security solutions. This honor reflects our relentless dedication, quiet excellence, and unwavering belief in the power of collaboration and innovation. In an increasingly complex and security-driven digital world, CloudMyLab has not only stood out—it’s been celebrated for consistently delivering mission-critical solutions that safeguard businesses and enable digital transformation. We take pride in solving real-world challenges, protecting our clients, and earning trust through transparency, resilience, and a commitment to continuous improvement.",
};

export const ACHIEVEMENTS_LIST = [
  {
    icon: MdOutlineVpnLock,
    title: "Best VPN Security Solution",
    pdfSrc: "/home/achievementsCertificate/VPNsec.pdf",
    desc: "Recognized for delivering enterprise-grade VPN protection with seamless user experience.",
  },
  {
    icon: GiFirewall,
    title: "Best Firewall Security Solution",
    pdfSrc: "/home/achievementsCertificate/FirewallSecSoln.pdf",
    desc: "Awarded for our next-gen firewall that redefines network perimeter security and threat prevention.",
  },
  {
    icon: MdSystemSecurityUpdateGood,
    title: "Best Security Solution for Virtual Applications / Virtual Desktops",
    pdfSrc: "/home/achievementsCertificate/SecSolution.pdf",
    desc: "Honored for securing virtualized environments with advanced threat detection and zero-trust access.",
  },
  {
    icon: MdManageSearch,
    title: "Best Incident Management Solution",
    pdfSrc: "/home/achievementsCertificate/IncidentManagement.pdf",
    desc: "Celebrated for our proactive incident response platform ensuring swift containment and recovery.",
  },
];
